<app-ot-breadcrumbs state="success"></app-ot-breadcrumbs>

<div class="container-fluid" *ngIf="registration">
  <div class="row">
    <div class="col-lg-9">
      <h1>{{ 'success_thanks' | l10n }}</h1>

      <div *ngIf="otEvent.registrationCreatedEmailId">
        <p *ngIf="registration.registrationReceivedMailSent">{{ 'success_emailSent' | l10n:[registration.person.email] }}</p>

        <p *ngIf="registration.registrationReceivedMailSent" class="spamNotice">
          {{ 'success_emailSent_spanNotice' | l10n }}
        </p>

        <div *ngIf="! registration.registrationReceivedMailSent" class="alert alert-warning mt1em">
          <strong>{{ 'warning' | l10n }}</strong>
          {{ 'success_emailSendingError' | l10n:[registration.person.email] }}
        </div>
      </div>

      <!-- <h2>{{ 'summary_title' | l10n }}</h2>

      <table class="displayTable">
        <tbody>
          <tr>
            <th>{{ 'summary_registration_number' | l10n }}</th>
            <td>{{ registration.id }}</td>
          </tr>
          <tr>
            <th>{{ 'summary_paymentType' | l10n }}</th>
            <td>{{ 'summary_paymentType_' + registration.paymentTypeConfig.paymentTypeCode | l10n }}</td>
          </tr>
          <tr>
            <th>{{ 'summary_registration_price' | l10n }}</th>
            <td>
              <span class="badge badge-secondary total-price" data-ng-class="{ 'price-change-alert': priceChangeAlert }">{{ registration.price | price }}</span>
              <span *ngIf="registration.registrationPriceModifiers && registration.registrationPriceModifiers.length > 0">
                = {{ registration.basicPrice }}
                <span data-ng-repeat="registrationPriceModifier in registration.registrationPriceModifiers">
                  {{ registrationPriceModifier.priceModifier.type.isDiscount ? '-' : '+' }}
                  {{ registrationPriceModifier.amount }}
                </span>
              </span>
            </td>
          </tr>
        </tbody>
      </table> -->

      <div *ngIf="registration.price">
        <h2>{{ 'summary_payment' | l10n }}</h2>

        <div *ngIf="! registration.paymentTypeConfig.paymentType.online">
          <div class="row">
            <div class="col-lg-7">
              <p>{{ 'summary_payment_bank_sendTo' | l10n }}</p>
              <table class="displayTable">
                <tbody>
                  <tr>
                    <th>{{ 'summary_registration_price' | l10n }}</th>
                    <td>
                      <span class="badge badge-secondary total-price">{{ registration.price | price }}</span>
                      <span *ngIf="registration.registrationPriceModifiers && registration.registrationPriceModifiers.length > 0">
                        = {{ registration.basicPrice }}
                        <span *ngFor="let registrationPriceModifier of registration.registrationPriceModifiers">
                          {{ registrationPriceModifier.priceModifier.type.isDiscount ? '-' : '+' }}
                          {{ registrationPriceModifier.amount }}
                        </span>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ 'summary_payment_bank_bankName' | l10n }}</th>
                    <td>{{ bankPaymentConfig.bankName }}</td>
                  </tr>
                  <tr *ngIf="bankPaymentConfig.bankAccountNumber">
                    <th>{{ 'summary_payment_bank_accountNumber' | l10n }}</th>
                    <td>{{ bankPaymentConfig.bankAccountNumber + ' / ' + bankPaymentConfig.bankNumber }}</td>
                  </tr>
                  <tr *ngIf="bankPaymentConfig.bankAccountNumber">
                    <th>{{ 'summary_payment_bank_iban' | l10n }}</th>
                    <td>{{ bankPaymentConfig.iban }}</td>
                  </tr>
                  <!--
                  <tr *ngIf="otEventInfo.specificSymbol">
                    <th>{{ 'summary_payment_bank_specificSymbol' | l10n }}</th>
                    <td>{{ otEvent.room.venue.specificSymbol }}</td>
                  </tr>
                  -->
                  <tr>
                    <th>{{ 'summary_payment_bank_variableSymbol' | l10n }}</th>
                    <td>{{ registration.id }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-lg-5">
              <div [hidden]="! paymentCodeResponse">
                <p class="description">{{ 'summary_payment_qrCode_desc' | l10n }}</p>
                <qr-code [hidden]="! paymentCodeResponse?.paymentCode" [value]="paymentCodeResponse?.paymentCode" [size]="232"></qr-code>
                <img *ngIf="paymentCodeResponse && paymentCodeResponse.qrCodeImage" [src]="paymentCodeResponse.qrCodeImage" alt="QR code" />
              </div>
            </div>
          </div>
          <div class="alert alert-warning mt1em"><strong>{{ 'warning' | l10n }}</strong> {{ 'summary_payment_bank_deadline' | l10n }}</div>
        </div>
        <div *ngIf="registration.paymentTypeConfig.paymentType.online">
          <div class="alert alert-success" role="alert">
            <fa-icon [icon]="['fas', 'check']"></fa-icon> {{ 'summary_successfullyPayed' | l10n }}
          </div>
        </div>
        <div *ngIf="organization.paymentNotes" class="summary-paymentNotes">
          <h3>{{ 'summary_payment_notes' | l10n }}</h3>
          <p class="description">{{ organization.paymentNotes }}</p>
        </div>
      </div>

      <div *ngIf="organization.afterRegistrationInfo" class="card org-additional-info-card">
        <div class="card-body">
          <h3 class="card-title"><fa-icon class="info-icon" [icon]="['fas', 'info-circle']"></fa-icon> {{ 'summary_afterRegistrationInfo' | l10n }}</h3>
          <div [innerHtml]="organization.afterRegistrationInfo"></div>
        </div>
      </div>

    </div>
    <div class="col-lg-3">
      <app-ot-event-info [otEvent]="otEvent" [changable]="false"></app-ot-event-info>
    </div>
  </div>
</div>
